import { appConfig } from '../config'

const { flowiseBaseUrl: baseURL } = appConfig

export const apiUrl = path => `${baseURL}/${path}`
